/**
 * Notification Message Formatter.
 *
 * @param {*} value
 * @param {*} row
 *
 * @returns {*}
 */
window.notificationMessageFormatter = function(value, row) {
    let html = '';
    switch (row.type) {
        case "App\\Notifications\\Monitoring\\Task\\Failed":
            html += vsprintf(__('%s (%s) &rarr; %s'), [
                row.data.monitoring.name,
                row.data.monitoring.type,
                row.data.message
            ]);
            break;
        case "App\\Notifications\\Domains\\Statistics\\Report":
            html += vsprintf(__('%s (%s) &rarr; %s'), [
                row.data.domain.name,
                row.data.domain.environment,
                row.data.message
            ]);
            break;
        default:
            break;
    }
    return html;
};
